import { BAKERY_STATUS_CHAOS, BAKERY_STATUS_BUSY, BAKERY_STATUS_BAKING, BAKERY_STATUS_QUIET_COOKIES } from "./config";
export function bakeryStatus(count: number, rush: boolean, cookies: number | bigint = 0): { label: string; cls: string } {
  if (rush) return { label: "Cookie Rush", cls: "rush" };
  if (count >= BAKERY_STATUS_CHAOS) return { label: "Absolute Cookie Chaos", cls: "chaos" };
  if (count >= BAKERY_STATUS_BUSY) return { label: "Busy", cls: "busy" };
  if (count >= BAKERY_STATUS_BAKING) return { label: "Baking", cls: "baking" };
  const n = typeof cookies === "bigint" ? Number(cookies) : cookies;
  if (n < BAKERY_STATUS_QUIET_COOKIES) return { label: "Quiet", cls: "quiet" };
  return { label: "Baking", cls: "baking" };
}

export function specLabel(spec: string): string {
  const low = spec.toLowerCase();
  if (low === "engineer") return "Engineer";
  if (low === "automation") return "Automation";
  if (low === "fortune") return "Fortune";
  if (low === "coordinator") return "Coordinator";
  return "Baker";
}

export function specTool(spec: string): string {
  if (spec === "Engineer") return "🔧";
  if (spec === "Automation") return "🤖";
  if (spec === "Fortune") return "🧤";
  if (spec === "Coordinator") return "📣";
  return "✋";
}
